import type { WebhookEventSubscriptionUpdate } from '../../typescript-types/webhook-event-subscriptions/webhook-event-subscription';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

import { humanize } from '../../util/formatters';
import { WebhookEventSubscriptionSubscriberType } from '../utils/webhook-event-subscription-utils';

export const updateWebhookEventSubscription = (
  webhookEventSubscriptionId: number,
  subscriberType: WebhookEventSubscriptionSubscriberType,
  update: WebhookEventSubscriptionUpdate,
  orgId: number,
) =>
  createGenericDispatcher({
    name: 'UPDATE_WEBHOOK_EVENT_SUBSCRIPTION',
    loadFunction: () =>
      Api.post(`/webhook-event-subscription/${webhookEventSubscriptionId}`, {
        body: JSON.stringify(update),
      }),
    args: { webhookEventSubscriptionId, update, orgId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `update-${humanize(subscriberType)}-webhook-event-subscription`,
          message: `Successfully updated ${humanize(subscriberType)} connection`,
        }),
      );
    },
  });
